import React, { useState, useCallback } from "react";
import secureLocalStorage from "react-secure-storage";
import Axios from "axios";
import "./muitab.css";

function Carton_cancel() {
  const isLoggedIn = secureLocalStorage.getItem("isLoggedIn");
  const [cartonno, setCartonno] = useState("");
  const [details, setDetails] = useState([]);
  const [alreadyCancelled, setAlreadyCancelled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const token = secureLocalStorage.getItem("token");

  const getAuthHeaders = useCallback(
    () => ({
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    }),
    [token],
  );

  const handleInputChange = useCallback((event) => {
    setCartonno(event.target.value);
  }, []);

  const search = useCallback(async () => {
    const carton_no = cartonno.trim();
    const regexPattern = /^[0-9a-zA-Z]{8}$/;

    if (!regexPattern.test(String(carton_no))) {
      window.alert("Wrong Carton Number");
      return;
    }

    try {
      setIsLoading(true);
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/label/carton_select`,
        { carton_no },
        getAuthHeaders(),
      );

      if (response.data.length > 0) {
        const isDispatched = response.data.some(
          (item) => item.is_despatched === "1",
        );

        if (isDispatched) {
          window.alert("Carton already dispatched");
          setDetails([]);
          setAlreadyCancelled(false);
          return;
        }
      }

      if (response.data.length === 0) {
        window.alert("No such Carton Number");
        setDetails([]);
        setAlreadyCancelled(false);
        return;
      }

      if (response.data[0].is_cancelled === "false") {
        setDetails(response.data);
        setAlreadyCancelled(false);
      } else {
        setDetails([]);
        setAlreadyCancelled(true);
      }
    } catch (error) {
      console.error(error);
      window.alert("Unable to fetch carton details");
    } finally {
      setIsLoading(false);
    }
  }, [cartonno, getAuthHeaders]);

  const cancel = useCallback(async () => {
    if (details.length === 0) {
      return;
    }

    const carton_no = details[0].carton_no;

    try {
      setIsLoading(true);
      await Axios.post(
        `${process.env.REACT_APP_API_URL}/label/carton_cancel`,
        { details },
        getAuthHeaders(),
      );

      window.alert("Carton Number " + carton_no + " has been cancelled");
      setDetails([]);
      setAlreadyCancelled(true);
      setCartonno("");
    } catch (error) {
      console.error(error);
      window.alert("Unable to cancel carton");
    } finally {
      setIsLoading(false);
    }
  }, [details, getAuthHeaders]);

  const clear = useCallback(() => {
    setCartonno("");
    setDetails([]);
    setAlreadyCancelled(false);
  }, []);

  return (
    <div>
      {isLoggedIn ? (
        <>
          <br />
          <h3 style={{ textAlign: "center" }} data-cy="order_label">
            Carton Cancel
          </h3>
          <div className="form-group">
            <br />
            <label className="label1">Carton No:</label>
            <input
              type="text"
              id="ordid"
              value={cartonno}
              onChange={handleInputChange}
              className="input"
            />
            <div align="left">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={search}
                disabled={isLoading}
              >
                Display
              </button>
              <button
                style={{ marginLeft: "20px" }}
                type="submit"
                className="btn btn-primary"
                onClick={clear}
                disabled={isLoading}
              >
                Clear
              </button>
            </div>
            <br />
            <br />
            {alreadyCancelled && <p>Label has already been Cancelled</p>}
          </div>
          <br />
          <br />
          {details.length > 0 ? (
            <table className="table container" id="tb1">
              <thead>
                <tr>
                  <th scope="col">Carton_no</th>
                  <th scope="col">PO Number</th>
                  <th scope="col">Article</th>
                  <th scope="col">Shade</th>
                  <th scope="col">Depo</th>
                  <th scope="col">Full qty</th>
                  <th scope="col">PackerID</th>
                  <th scope="col">Status </th>
                </tr>
              </thead>
              <tbody>
                {details.map((detail, index) => (
                  <tr key={`${detail.carton_no}-${index}`}>
                    <td>{detail.carton_no}</td>
                    <td>{detail.po_number}</td>
                    <td>{detail.article}</td>
                    <td>{detail.shade}</td>
                    <td>{detail.depot}</td>
                    <td>
                      {detail.cartontype === "Loose"
                        ? detail.fullqty
                        : detail.at_cc}
                    </td>
                    <td>{detail.packerid}</td>
                    <td>{detail.statuscode}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="8" align="right">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={cancel}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <p></p>
          )}
        </>
      ) : (
        (window.location.href = "#/login")
      )}
    </div>
  );
}
export default Carton_cancel;
